var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 text-left w-100"},[(!_vm.isSide)?_c('div',{attrs:{"id":"allmap"}}):_c('div',{attrs:{"id":"smallmap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }